<template>
  <div class="home-wrapper" ref="homeWrapper">
    <!-- <Nav v-model="showNav" @toggleNav="handleToggleNav" v-if="renderNav" ref="nav" /> -->
    <Banner @clickAsideBtn="handleShowChooseActivityPicker" :bannerImg="heroActivityApiVo.mobileBack" :btnAsideText="switchActivityBtnText" />
    <div class="content-wrapper" :style="{ backgroundImage: backgroundColor }">
      <ActivityIntroduce :titleImg="heroActivityApiVo.intrImage" :content="heroActivityApiVo.actiIntr" />
      <InteractionBtns :interactionBtns="interactionBtns" @click="handlePrasie" />
      <MessageBoard @clickMore="handlekJumpMessageCard" id="messageBoard" v-if="showMessageBord" :showAction="showMessageBoardAction" />
      <ArticlePanel
        v-for="item in articlePanelModules"
        :key="item.id"
        @clickMore="handleJumpArticle"
        :id="item.targetId"
        :titleIcon="item.titleImg"
        :title="item.label"
        :articlePanelInfo="item"
        :articleList="item.articleList"
      />
      <!-- 各地区数据分布 -->
      <RegionData v-if="areaDataDistribution" :areaDataDistribution="areaDataDistribution" :distributionTitlePic="distributionTitlePic" :areaDistributionResult="areaDistributionResult"></RegionData>
      <InvolvedMember :involvedMember="involvedMember" />
      <DownloadNfPlus v-if="!systemInfo.isNfPlus" />
    </div>
    <BottomBtns :showLeaveMessageBtn="showMessageBord" @leaveMessage="handleLeaveMessage" @sharePoster="handleSharePoster" />
    <ChooseActivityPicker v-model="showChooseActivityPicker" :activityList="activityList" />
    <MessageListchoose v-model="MessageListchooseShow" />
  </div>
</template>

<script>
import Banner from "@/components/Banner"
import ActivityIntroduce from "@/components/ActivityIntroduce"
import InteractionBtns from "@/components/InteractionBtns"
import MessageBoard from "@/components/MessageBoard"
import ArticlePanel from "@/components/ArticlePanel"
import InvolvedMember from "@/components/InvolvedMember"
import DownloadNfPlus from "@/components/DownloadNfPlus"
import BottomBtns from "@/components/BottomBtns"
import ChooseActivityPicker from "@/components/ChooseActivityPicker"
// import Nav from "@/components/Nav"
import remToPx from "@/utils/remToPx"
import MessageListchoose from "@/components/MessageListchoose"
import { mapMutations, mapGetters, mapActions } from "vuex"
import { buryingPoint, sentMessage } from "@/server/interfaces"
import RegionData from "@/components/RegionData"

const TITLE_ICON_1 = require("../../../../assets/images/tag.png")
const TITLE_ICON_2 = require("../../../../assets/images/tag3.png")
const MODULE_NAV_OFFSET_DIS = remToPx(3.5)

export default {
  name: "home",
  data() {
    return {
      showChooseActivityPicker: false,
      moduleOffsetTop: {},
      navActiveIndex: 0,
      showNav: false,
      MessageListchooseShow: false
    }
  },
  methods: {
    ...mapMutations({
      showLoading: "loading/showLoading",
      hideLoading: "loading/hideLoading",
      setMyMessageList: "activityInfo/setMyMessageList",
      setMessageBoardOutViewPort: "activityInfo/setMessageBoardOutViewPort",
      setUserInfo: "userInfo/setUserInfo"
    }),
    ...mapActions({
      enableUpdateMessageList: "activityInfo/enableUpdateMessageList",
      disableUpdateMessageList: "activityInfo/disableUpdateMessageList",
      getActivityDetail: "activityInfo/getActivityDetail",
      handleInteractionprasie: "activityInfo/handleInteractionprasie",
      getTemplateList: "activityInfo/getTemplateList",
      updateNewMesageList: "activityInfo/updateNewMesageList",
      getMyMessageList: "activityInfo/getMyMessageList"
    }),
    handleShowChooseActivityPicker() {
      this.showChooseActivityPicker = true
    },
    handleLeaveMessage() {
      this.MessageListchooseShow = true
    },
    async handleSharePoster() {
      if (this.templateList && this.templateList.length == 0) {
        await this.getTemplateList()
      }
      if (this.myMessageList.length == 0) {
        let params = {
          refColumn: this.activityDetail.columnId,
          refTemplate: this.templateList[0].id,
          userName: this.userInfo.userName,
          likeCount: this.maxCount + 1
        }
        await this.getMyMessageList()
        let res = await sentMessage({ params })
        if (res) {
          if (String(res) !== "true") {
            this.setUserInfo({ userName: res })
          }
          let myMessageList = this.myMessageList
          myMessageList.unshift({ message: this.templateList[0].copywriting, likeCount: params.likeCount })
          this.setMyMessageList(myMessageList)
          this.updateNewMesageList([{ message: this.templateList[0].copywriting, userName: this.userInfo.userName }])
        }
        this.$router.push({ path: "/poster", query: this.$route.query })
      } else {
        this.$router.push({ path: "/poster", query: this.$route.query })
      }
    },
    handlekJumpMessageCard() {
      this.$router.push({ path: "/poster", query: this.$route.query })
    },
    handleJumpArticle() {},
    initTargetModuleOffsetTop() {
      this.$nextTick(() => {
        this.moduleOffsetTop = {}
        const homeDom = this.$refs.homeWrapper
        this.navList.forEach(item => {
          const id = item.targetId
          const targetDom = document.getElementById(id)
          if (targetDom) {
            const offsetY = homeDom.scrollTop + targetDom.getBoundingClientRect().top
            const key = id
            this.moduleOffsetTop[key] = offsetY
          }
        })
      })
    },
    handleToggleNav(navItem) {
      const targetOffsetY = this.moduleOffsetTop[navItem.targetId] || 0
      const navHeight = remToPx(0.96)
      const homeDom = this.$refs.homeWrapper
      if (homeDom) {
        let scrollTop = targetOffsetY === 0 ? 0 : targetOffsetY - navHeight - MODULE_NAV_OFFSET_DIS
        const scrollHeight = homeDom.scrollHeight
        scrollTop > scrollHeight && (scrollTop = scrollHeight)
        homeDom.scrollTop = scrollTop
      }
    },
    toggleNav(scrollTop) {
      this.showNav = scrollTop > 100 && this.navList.length > 1
    },
    toggleNavActiveIndex(scrollTop) {
      const navHeight = remToPx(0.96)
      let offsetYArr = Object.keys(this.moduleOffsetTop).map(key => this.moduleOffsetTop[key])
      if (!offsetYArr.length) return
      offsetYArr = offsetYArr.reverse()
      let activeIndex = offsetYArr.findIndex(offsetY => {
        return scrollTop + navHeight >= offsetY - MODULE_NAV_OFFSET_DIS - navHeight
      })
      const index = activeIndex > -1 ? offsetYArr.length - activeIndex - 1 : activeIndex
      this.$refs.nav.handleSetActiveIndex(index + 1)
    },
    initNavActiveIndex() {
      this.$nextTick(() => {
        const scrollTop = this.$refs.homeWrapper.scrollTop
        this.toggleNavActiveIndex(scrollTop)
        this.toggleNav()
      })
    },
    toggleUpdateMessageList() {
      const messageBoard = document.getElementById("messageBoard")
      const offsetY = messageBoard.getBoundingClientRect().top
      const isOutViewPort = offsetY < 0
      this.setMessageBoardOutViewPort(isOutViewPort)
      if (isOutViewPort) {
        this.disableUpdateMessageList()
      } else {
        this.enableUpdateMessageList()
      }
    },
    initScroll() {
      window.onscroll = this.scroll
    },
    destroyScroll() {
      window.onscroll = null
    },
    scroll() {
      if (this.scrollTimer) {
        window.clearTimeout(this.scrollTimer)
        this.scrollTimer = null
      }
      this.scrollTimer = window.setTimeout(() => {
        this.toggleUpdateMessageList()
        // const target = e.target
        // const scrollTop = target.scrollTop
        // this.toggleNav(scrollTop)
        // this.toggleNavActiveIndex(scrollTop)
      }, 20)
    },
    handlePrasie(interactionItem) {
      this.handleInteractionprasie(interactionItem)
    },
    _buryingPointVisitHome() {
      buryingPoint({
        params: {
          action: 1
        }
      })
    },
    async init() {
      this._buryingPointVisitHome()
      await this.getActivityDetail()
      if (this.activityDetail.heroActivityApiVo.actiStatus !== 1) {
        this.$router.replace("/nothingnessActivity")
      }
      this.initScroll()
      // this.initTargetModuleOffsetTop()
    }
  },
  components: {
    Banner,
    ActivityIntroduce,
    InteractionBtns,
    MessageBoard,
    ArticlePanel,
    InvolvedMember,
    DownloadNfPlus,
    BottomBtns,
    ChooseActivityPicker,
    // Nav,
    MessageListchoose,
    RegionData
  },
  computed: {
    ...mapGetters({
      systemInfo: "systemInfo",
      navList: "activityInfo/navList",
      activityDetail: "activityInfo/activityDetail",
      heroActivityApiVo: "activityInfo/heroActivityApiVo",
      backgroundColor: "activityInfo/backgroundColor",
      interactionBtns: "activityInfo/interactionBtns",
      showMessageBord: "activityInfo/showMessageBord",
      articlePanelModules: "activityInfo/articlePanelModules",
      myMessageList: "activityInfo/myMessageList",
      activityList: "activityInfo/activityList",
      involvedMember: "activityInfo/involvedMember",
      maxCount: "activityInfo/maxCount",
      messageList: "messageTemplate/messageList",
      userInfo: "userInfo/userInfo",
      switchActivityBtnText: "activityInfo/switchActivityBtnText",
      templateList: "activityInfo/templateList",
      distributionTitlePic: "activityInfo/distributionTitlePic",
      areaDistributionResult: "activityInfo/areaDistributionResult",
      areaDataDistribution: "activityInfo/areaDataDistribution"
    }),
    titleIcon1() {
      return TITLE_ICON_1
    },
    titleIcon2() {
      return TITLE_ICON_2
    },
    showMessageBoardAction() {
      return this.myMessageList.length > 0
    },
    renderNav() {
      return this.navList.length > 1
    }
  },
  async created() {
    this.init()
  },
  activated() {
    this.initScroll()
    // this.initNavActiveIndex()
  },
  beforeDestroy() {
    this.destroyScroll()
  },
  beforeRouteLeave(from, to, next) {
    this.destroyScroll()
    next()
  }
}
</script>

<style lang="scss" scoped>
.home-wrapper {
  min-height: 100%;
  width: 100%;
  overflow: visible;
  .content-wrapper {
    padding: 0 0.3rem 1.68rem;
    position: relative;
    z-index: 2;
    width: 100%;
    ::v-deep .ui-activity-introduce-wrapper {
      transform: translate3d(0, -0.3rem, 0);
    }
  }
}
</style>
